import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BibliothequeRoutingModule } from './bibliotheque-routing.module';
import { BibliothequeComponent } from './components/home/bibliotheque.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [BibliothequeComponent],
  imports: [CommonModule, BibliothequeRoutingModule, SharedModule],
})
export class BibliothequeModule {}
